import React, { useEffect, ChangeEvent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getUser, saveUser } from '../../../store/actions/management'
import TextInput from '../../../components/TextInput'
import { GetUser, UpdateUserField } from '../../../store/actions/actionTypes'
import { UserColumns, IUser, UserRole } from '../../../shared/models/adminModels'
import { IFormState } from '../../../shared/models/validations'
import { checkFieldValidation, checkProperties } from '../../../services/utilService'
import update from 'react-addons-update'
import BackButton from '../../../components/BackButton'

const ManageUser = (props: any) => {
    const { user } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [userForm, setUserForm] = useState<IFormState>({
        valid: false,
        errors: {},
        validations: {
            [UserColumns.ContactFirstName]: {
                label: 'FirstName',
                required: true,
            },
            [UserColumns.ContactSurName]: {
                label: 'LastName',
                required: true,
            },
            [UserColumns.Email]: {
                label: 'Email',
                required: true,
                email: true
            }
        }
    });
    const { id } = useParams();
    useEffect(() => {
        if (id) {
            setIsEdit(true);
            props.getUser(id);
        } else {
            setIsEdit(false);
            props.setUser({});
            props.updateUserField('active', true);
            props.updateUserField('userType', UserRole.Admin);
        }
    }, []);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { type, name, value, checked } = e.target;
        if (type === 'checkbox') {
            props.updateUserField(name, checked);
            return false;
        }
        props.updateUserField(name, value);
        if (Object.keys(userForm.validations).includes(name)) {
            const error = checkFieldValidation(userForm.validations[name], value);
            setUserForm(update(userForm, {
                errors: {
                    [name]: { $set: error }
                }
            }))
        }
    }

    const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        props.updateUserField(name, value);
        if (Object.keys(userForm.validations).includes(name)) {
            const error = checkFieldValidation(userForm.validations[name], value);
            setUserForm(update(userForm, {
                errors: {
                    [name]: { $set: error }
                }
            }))
        }
    }

    const checkFormValidation = () => {
        let errors: any = {};
        Object.keys(userForm.validations).forEach(field => {
            errors[field] = checkFieldValidation(userForm.validations[field], user[field]);
        });
        return errors;
    }

    const saveUser = async () => {
        const errors = await checkFormValidation();
        const form = {
            ...userForm,
            errors
        }
        setUserForm(form);
        const noError = checkProperties(form.errors);
        if (noError) {
            let params= {}
            if(isEdit) {
                params = {
                    id,
                    role: +user.userType,
                    active: user.active
                }
            } else {
                params = {
                        "role": +user.userType,
                        "email": user.email,
                        "contactFirstName": user.contactFirstName,
                        "contactSurname": user.contactSurname,
                        "jobTitle": user.jobTitle,
                        "active": user.active
                };
            }
            const saved = await props.saveUser(params, isEdit);
            if (saved) {
                props.history.goBack();
            }
        }
    }

    const { errors } = userForm;
    return (
        <div className="container-fluid profile-width-control">
            <div className="page-header">
                <h1>{isEdit ? 'User Profile' : 'Create User'}</h1>
                <BackButton/>
            </div>

            <div className="page-content ">
                <div className="row">
                    <div className="profile-card  box-shaddow  border-btm-blue mb-5 w-100">
                        {!!isEdit &&
                            <div className="profile-top">
                                <h3 className="mt-5">{user.userName}</h3>
                            </div>
                        }
                        <div className="profile-status">
                            <div className="pro-status-wrap">
                                <div className="status-text">Active</div>
                                <div className="custom-control custom-switch">
                                    <TextInput type="checkbox" className="custom-control-input" id="customSwitch1" name="active"
                                        checked={isEdit ? user.active : true}
                                        disabled={!isEdit}
                                        onChange={handleChange}
                                        data-size="lg" />
                                    <label className="custom-control-label" htmlFor="customSwitch1"></label>
                                </div>
                            </div>
                        </div>
                        <div className="profile-content">
                            <form action="" className="witt-check">
                                <div className="form-group role-select">
                                    <select className="form-control selectpicker btn btn-light" name="userType" value={user.userType|| null} onChange={handleSelectChange}>
                                        { Object.entries(UserRole).map((type) => (
                                            isNaN(Number(type[0])) && <option key={type[1]} value={type[1]}>{type[0]}</option>
                                        ))}
                                    </select>
                                    <div className="permission">
                                        <span className="round blue mr-2"></span>
                                        <span className="round blue mr-2"></span>
                                        <span className="round blue"></span>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Email Address</label>
                                    <TextInput placeholder="Email Address" name="email"
                                        value={user.email}
                                        disabled={isEdit}
                                        error={errors.email}
                                        onChange={handleChange} />
                                </div>
                                <div className="form-group">
                                    <label>First Name</label>
                                    <TextInput placeholder="First Name" name="contactFirstName"
                                        value={user.contactFirstName}
                                        disabled={isEdit}
                                        error={errors.contactFirstName}
                                        onChange={handleChange} />
                                </div>
                                <div className="form-group">
                                    <label>Last Name</label>
                                    <TextInput placeholder="Last Name" name="contactSurname"
                                        value={user.contactSurname}
                                        disabled={isEdit}
                                        error={errors.contactSurname}
                                        onChange={handleChange} />
                                </div>
                                <div className="form-group">
                                    <label>Job Title</label>
                                    <TextInput placeholder="Job Title" name="jobTitle"
                                        value={user.jobTitle}
                                        disabled={isEdit}
                                        error={errors.jobTitle}
                                        onChange={handleChange} />
                                </div>
                                <div className="form-group">
                                    <button disabled={props.isLoading} type="button" onClick={() => saveUser()} className="btn btn-primary w-100 mb-2">Save</button>
                                    <button className="btn btn-outline w-100" onClick={() => props.history.push('/manage-users')}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: any) => {
    return ({
        user: state.managementReducer.user,
        isLoading: state.common.isLoading
    })
}

const mapDispatchToProps = (dispatch: any) => ({
    getUser: bindActionCreators(getUser, dispatch),
    saveUser: bindActionCreators(saveUser, dispatch),
    setUser: (user: IUser) => dispatch({ type: GetUser, payload: user }),
    updateUserField: (field: string, value: string | number) => dispatch({ type: UpdateUserField, payload: { field, value } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUser);